import React, { FC, useEffect, useState, useRef } from 'react';
import styles from './scroll-to-top.module.scss';

const ScrollToTop: FC = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const lineRef = useRef<HTMLDivElement>(null);
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={styles.scoll_container}>
      <div className="line" ref={lineRef}>
        <div className="icon_box">
          <img
            className="icon"
            src="assets/images/scroll-to-top/Vector-light.svg"
            alt="Vector"
          />
          <img
            className="icon"
            src="assets/images/scroll-to-top/Vector-dark.svg"
            alt="Vector"
          />
          <div className="icon_text">Scroll</div>
        </div>
      </div>
      {/* 根據滾動位置顯示/隱藏按鈕 */}
      <button 
         className={`toTopBtn ${scrollPosition > 200 ? 'visible' : 'hidden'}`}
        onClick={scrollToTop}
      >
        <img src="assets/images/scroll-to-top/Up.svg" alt="UP" />
      </button>
    </div>
  );
};

export default ScrollToTop;